import { render, staticRenderFns } from "./testo.vue?vue&type=template&id=04830f43"
import script from "./testo.vue?vue&type=script&lang=js"
export * from "./testo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports